import React from "react";
import { useNavigate } from "react-router-dom";
import omnicareLogo from "../../assets/icons/logo.svg";
import LanguageSwitcher from "../LanguageSwitcher";
import "../../styles/components/EnergyLanding.css";

const EnergyLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="energy-landing">
      {/* Header */}
      <header className="energy-header">
        <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: "pointer" }}>
          <img src={omnicareLogo} alt="Pebble Health" className="logo-icon" />
          <span className="logo-text">Pebble Health</span>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
        </div>
      </header>

      {/* Hero */}
      <main className="energy-hero">
        <div className="energy-hero-badge">🧬 Huberman Lab + Dr. Stacy Sims protocols</div>
        <h1 className="energy-hero-title">
          Let's optimize your biology
        </h1>
        <p className="energy-hero-subtitle">
          Get a research-backed assessment of your circadian rhythm, energy patterns, and recovery protocols. 
          Based on real science from Huberman Lab and Dr. Stacy Sims — not generic wellness advice.
        </p>

        <button className="energy-cta-button" onClick={() => navigate("/energy/quiz/1")}>
          Get My Optimization Protocol
        </button>

        {/* Value Props */}
        <div className="energy-value-props">
          <div className="energy-prop">
            <span className="energy-prop-icon">☀️</span>
            <div>
              <strong>Circadian Analysis</strong>
              <p>Light exposure, sleep timing</p>
            </div>
          </div>
          <div className="energy-prop">
            <span className="energy-prop-icon">💪</span>
            <div>
              <strong>Performance Insights</strong>
              <p>Movement, stress, recovery</p>
            </div>
          </div>
          <div className="energy-prop">
            <span className="energy-prop-icon">🧪</span>
            <div>
              <strong>Research-Backed Recs</strong>
              <p>Supplements with citations</p>
            </div>
          </div>
        </div>

        {/* Trust */}
        <p className="energy-trust">
          🔒 100% free · Protocol-level insights · Science > opinion
        </p>
      </main>
    </div>
  );
};

export default EnergyLandingPage;
